import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="min-h-screen bg-navy-950 flex items-center justify-center">
        <div className="relative w-24 h-24">
          <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-gold animate-spin" />
          <div className="absolute inset-2 rounded-full bg-white flex items-center justify-center p-2">
            <img src="/logo-mark.png" alt="Claimspace LegalTech" className="w-full h-full object-contain" />
          </div>
        </div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/portal/login" replace />;
  if (role && user.role !== role) return <Navigate to="/portal" replace />;
  return children;
}
